export const formatTimestamp = (timestamp: string): string => {
    const date = new Date(timestamp);
    const dateStr = date.toLocaleDateString('en-US', {year: 'numeric', month: 'short', day: 'numeric'});
    const timeStr = date.toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit', hour12: false});
    return `${dateStr}, ${timeStr}`;
};
